import { Dropdown, Menu, TableColumnsType } from "antd";

import { ICountry, IRegion } from "@types";
import { ReactComponent as MenuIcon } from "@assets/images/vertical-dots.svg";
import { ReactComponent as FilterIcon } from "@assets/images/filter.svg";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { BsTrash3 } from "react-icons/bs";
import { GoPencil } from "react-icons/go";

export type TableRow = {
  id: number;
  name: string;
  countries: ICountry[];
  business_units: any;
};

export const getColumns = (
  handleActionDropdown: ({
    item,
    key,
    domEvent,
  }: {
    key: string;
    domEvent:
      | React.MouseEvent<HTMLElement, MouseEvent>
      | React.KeyboardEvent<HTMLElement>;
    item: IRegion;
  }) => void
): TableColumnsType<TableRow> => {
  const columns: TableColumnsType<TableRow> = [
    {
      title: "region name",
      dataIndex: "name",
      key: "name",
      width: 300,
      render: (name: string) => <div className="text-wrap">{name}</div>,
    },

    {
      title: "Countries",
      dataIndex: "countries",
      key: "countries",
      width: 300,
      filters: [],
      filterIcon: <FilterIcon className="table__filter__icon" />,
      render: (countries: ICountry[]) => (
        <div className="text-wrap">
          {countries?.map(({ name }) => name).join(", ")}
        </div>
      ),
    },
    {
      title: "business unit",
      dataIndex: "business_units",
      key: "businessUnit",
      width: `calc(100% - 760px)`,
      filters: [],
      filterIcon: <FilterIcon className="table__filter__icon" />,
      render: (units: { name: string; id: number }[]) => (
        <div className="text-wrap">
          {units?.map(({ name }) => name).join(", ")}
        </div>
      ),
    },
  ];

  if (checkPermission([permissions.UPDATE_REGION, permissions.DELETE_REGION])) {
    columns.push({
      title: "Actions",
      key: "action",
      fixed: "right",
      align: "center",
      width: 220,
      render: (item: IRegion) => (
        <div className="table__actions flex items-center gap-2">
          {checkPermission(permissions.UPDATE_REGION) && (
            <div
              className="table__action__btn table__action__btn--client"
              onClick={e =>
                handleActionDropdown({
                  item,
                  key: "1",
                  domEvent: e,
                })
              }
            >
              <GoPencil className="text-white mr-1 text-sm" /> Edit
            </div>
          )}

          {checkPermission(permissions.DELETE_REGION) && (
            <div
              className="table__action__btn table__action__btn--delete"
              onClick={e =>
                handleActionDropdown({
                  item,
                  key: "2",
                  domEvent: e,
                })
              }
            >
              <BsTrash3 className="text-white textx mr-1" /> Delete
            </div>
          )}
        </div>
      ),
    });
  }

  return columns;
};
